import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import qs from 'qs';
import { toLogin } from '/@/utils/index';
import { clearNoValueObj } from '/@/utils/mixin';
import { Session } from '/@/utils/storage';

const { VITE_APP_ENV, VITE_API_URL, VITE_API_GATEWAY } = import.meta.env;

// 配置新建一个 axios 实例
const service: AxiosInstance = axios.create({
  timeout: 50000,
  headers: { 'Content-Type': 'application/json', 'Accept-Language': 'zh_CN' },
  withCredentials: true,
  paramsSerializer: {
    serialize(params) {
      const copy_params = clearNoValueObj(params);
      return qs.stringify(copy_params, { allowDots: true });
    },
  },
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = Session.get('access_token');
    const admin_token = Session.get('admin_access_token');
    if (admin_token) {
      Session.set('admin_access_token', token);
    }

    // 在发送请求之前做些什么 token
    const { url, baseURL } = config;
    config.baseURL =
      VITE_APP_ENV === 'development'
        ? baseURL
          ? `${VITE_API_URL}${baseURL}`
          : `${VITE_API_URL}${VITE_API_GATEWAY}`
        : baseURL
        ? `${baseURL}`
        : `${VITE_API_GATEWAY}`;

    if (url?.includes('oauth2')) {
      config.baseURL = '';
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    // 二进制数据则直接返回
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return response.data;
    }
    // 对响应数据做点什么
    const res = response.data;
    if (res.code === -1 || res.statusCode === '001') {
      ElMessage({
        type: 'error',
        message: '登录状态已失效，请重新登录',
        grouping: true,
        onClose: () => {
          toLogin();
        },
      });
      return Promise.reject(service.interceptors.response);
    } else {
      return res;
    }
  },
  (error) => {
    // 对响应错误做点什么
    if (error.message.indexOf('timeout') !== -1) {
      ElMessage.error('网络超时');
    } else if (error.message === 'Network Error') {
      ElMessage.error('网络连接错误');
    } else {
      if (error.response.data) ElMessage.error(error.response.statusText);
      else ElMessage.error('接口路径找不到');
    }
    return Promise.reject(error);
  }
);

// 导出 axios 实例
export default service;
